<template src="./EmployeeSpreadSheet.html"></template>

<script>
import { computed } from 'vue'
import moment from "moment"

import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"
import Swal from 'sweetalert2'
import SuccessIcon from "@/assets/svg/employee-success-import.svg"


export default {
  name: 'EmployeeSpreadSheet',
  components: { WholeMultiselect },
  mixins: [mixins],
  setup () {
    const store = useStore()

    return {
      fileExtAllowed: ['xlsx'],
      fileSizeLimit: 90,
      isMobile: computed(() => store.getters.isMobile),
      getCompanyUploadRegisters: (page) => store.dispatch("getCompanyUploadRegisters", page),
      getCompanySignaturesList: (id) => store.dispatch("getCompanySignaturesList", id),
    }
  },
  data () {
    return {
      documentData: "",
      employess: [],
      file: null,
      files: [],
      currentx: 1,
      numPages: 0,
      fileTarget: null,
      showModalPlans: false,
      showModalProcess: false,
      signatureList: [],
      signatureSelected: null,
      lastFileId: null,
      lastFileName: null,
      modalProcessIcon: null,
      modalProcessTitle: null,
      modalProcessMessage: null,
    }
  },
  computed: {
    isPaginated () {
      return this.numPages > 1
    }
  },
  async mounted () {
    const signatureList = await this.getCompanySignaturesList(this.$route.params.id)

    this.signatureList = signatureList.map((signature) => ({
      ...signature,
      name_code: `${signature.name} (${signature.code})`,
    }))

    await this.getEmployeesList()
  },
  watch: {
    currentx () {
      this.changePagination()
    },
  },
  methods: {
    checkExtension (file) {
      if (!this.fileExtAllowed.includes(file.name.split('.').pop())) {
        this.$vs.notify({
          title: "Atenção!",
          text: "Formato do arquivo incorreto, utilizar o formato .xlsx",
          color: "warning",
          icon: "error",
          position: "top-right",
        })
      } else {
        return true
      }
    },
    checkSize (file) {
      if ((file.size / 1024 / 1024) > this.fileSizeLimit) {
        this.$vs.notify({
          title: "Atenção!",
          text: `O arquivo "${file.name}" ultrapassou o tamanho permitido de 90MB!`,
          color: "warning",
          icon: "error",
          position: "top-right",
        })
      } else {
        return true
      }
    },
    clearTarget () {
      this.file = null
      this.signatureSelected = null

      if (this.fileTarget) {
        this.fileTarget.value = null
      }
    },
    async getEmployeesList () {
      const page = this.currentx > 1 ? this.currentx - 1 : 0

      const response = await this.getCompanyUploadRegisters(page)

      this.numPages = response.totalPages
      this.employess = response.content.map((employee) => {
        employee.tooltip = { message: "Verificando", icon: "", class: "loader" }
        employee.createDateText = employee.createDate
          ? moment(employee.createDate).format("DD/MM/YYYY HH:mm")
          : null

        if (employee.status) {
          if (employee.status === "FINISHED_AND_IMPORTED" || employee.status === "FINISHED") {
            employee.tooltip.message = "Processado com sucesso"
            employee.tooltip.icon = "check_circle_outline"
            employee.tooltip.class = "material-icons check_circle_outline"
          } else if (employee.status === "PROCESSING") {
            employee.tooltip.message = "Em processamento"
            employee.tooltip.icon = "access_time"
            employee.tooltip.class = "material-icons access-time"
          } else if (employee.status === "FINISHED_WITH_ERRORS") {
            employee.tooltip.message = "Processado parcialmente"
            employee.tooltip.icon = "error_outline"
            employee.tooltip.class = "material-icons error_outline_warning"
          } else {
            employee.tooltip.message = "Processado com erro"
            employee.tooltip.icon = "do_not_disturb_alt"
            employee.tooltip.class = "material-icons error_outline"
          }
        }

        return employee
      })
    },
    async handleClickHide () {
      this.clearTarget()

      this.showModalPlans = false
    },
    async handleClickHideProcess () {
      this.clearTarget()
      this.showModalProcess = false
    },
    async handleClickConfirm () {
      this.showModalPlans = false
      this.$vs.loading()

      const formData = new FormData()
      formData.append("file", this.file)
      formData.append("customerPlanId", this.signatureSelected.id)

      this.axios.post(
        `${this.$store.state.filooServer}company/users/upload/save`,
        formData,
        {
          headers: { Authorization: this.$session.get("bearer") },
          "Content-Type": "multipart/form-data",
        }
      )
        .then(({ status, data }) => {
          if (status === 200) {

            this.$swal({
              title: "Importação realizada com sucesso!",
              text: "O arquivo está sendo processado e estará disponível para download em alguns instantes.",
              icon: "success",
            })

            this.getEmployeesList()
            this.verifyFile(data.id)
            this.lastFileId = data.id
            this.lastFileName = data.excelFilename

            this.$vs.loading.close()
          }
        })
        .catch((error) => {
          this.$vs.loading.close()

          console.error({ error })
          this.$swal({
            title: "Atenção!",
            text: error.data.message,
            icon: "error",
          })
        })
    },
    async handleClickAddFile ({ target }) {
      this.fileTarget = target
      this.file = this.fileTarget.files[0]

      if (this.checkExtension(this.file) && this.checkSize(this.file)) {
        this.showModalPlans = true
      } else {
        this.clearTarget()
      }
    },
    async handleDragAddFile (evt) {
      const dragFiles = evt.dataTransfer.files
      this.file = dragFiles[0]

      if (this.checkExtension(this.file) && this.checkSize(this.file)) {
        this.showModalPlans = true
      } else {
        this.clearTarget()
      }
    },
    verifyFile (fileId) {
      const interval = setInterval(() => {
        this.axios.get(
          `${this.$store.state.filooServer}company/sheet-card/status/${fileId}`, {
          headers: { Authorization: this.$session.get("bearer") },
        })
          .then((response) => {
            if (response.data.status !== 'PROCESSING') {
              const swalContainer = document.querySelector('.swal2-container')
              if (swalContainer) {
                if (Swal.isVisible()) {
                  Swal.close()
                } else {
                  swalContainer.remove()
                }
              }
              this.verifyStatusPos(response.data.status)
              clearInterval(interval)
              this.getEmployeesList()
            }
          })
          .catch((error) => console.error({ error: error }))
      }, 5000)
    },
    verifyStatusPos (status) {
      if (status) {
        this.modalProcessIcon = SuccessIcon
        this.modalProcessTitle = 'Processamento realizado!'
        this.modalProcessMessage = 'Sua carga foi processada, verifique o status do processamento na coluna “Status”.'
      }

      this.showModalProcess = true
    },
    handleDownloadProcess () {
      if (!this.lastFileId && !this.lastFileName) {
        this.$swal({
          title: "Erro",
          text: "Não é possível baixar o arquivo. Verifique os detalhes do processamento.",
          icon: "error",
        })
      } else {
        this.getFile(this.lastFileId, this.lastFileName)
      }
    },
    getFile (id, name) {
      this.$vs.loading()

      this.axios.get(
        `${this.$store.state.filooServer}company/upload-registers/${id}/download/${name}.xlsx`,
        {
          headers: { Authorization: this.$session.get("bearer") },
          responseType: "arraybuffer",
        }
      )
        .then((response) => {
          if (response.status === 200) {
            this.getCompiledFile(response.data, name)
          }
        })
        .catch((error) => {
          console.error({ error: error })
          this.$swal({
            title: "Atenção!",
            text: "Não foi possível realizar esta operação contacte o administrador do sistema.",
            icon: "error",
          })
        })
    },
    getTemplate () {
      this.$vs.loading()

      this.axios.get(
        `${this.$store.state.filooServer}company/excel/template.xlsx`,
        {
          headers: { Authorization: this.$session.get("bearer") },
          responseType: "arraybuffer",
        }
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.getCompiledFile(data, 'Arquivo para Importação de Funcionários')
          }
        })
        .catch((error) => {
          console.error({ error: error })
          this.$swal({
            title: "Atenção!",
            text: "Não foi possível realizar esta operação contacte o administrador do sistema.",
            icon: "error",
          })
        })
    },
    getCompiledFile (file, name) {
      const link = document.createElement("a")

      link.id = `link-${Math.floor(Math.random() * 10000000)}`
      link.href = window.URL.createObjectURL(new Blob([file]))
      link.setAttribute("download", `${name}.xlsx`)

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)

      this.$vs.loading.close()
    },
    changePagination () {
      this.getEmployeesList()
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  },
}
</script>

<style lang="scss" src="./EmployeeSpreadSheet.scss"></style>
